import React from "react";
import {H1, Text} from "@reside/ui";
import {Spinner} from "../../spinner";

export const GeneratingPdfLoader = () => {
  return (
    <div style={{marginTop: "40px", height: "300vh"}}>
      <Spinner />
      <H1 fontSize={[3, 5]}>Generating your PDF...</H1>

      <Text as="p" fontSize={[3, 4]}>
        This may take up to a minute. Thank you for your patience.
      </Text>
    </div>
  );
};
